import React from 'react'
import './Airsial.css'

function Airsial() {
  return (
    <div className="main-airsial-container">
      {/* Hero section with background image and overlay */}
      <div className="airsial-hero">
        <div className="airsial-overlay">
          <h1>Air Sial</h1>
        </div>
      </div>
      
      {/* White gap */}
      <div className="white-gap"></div>
      
      {/* Content section with Air Sial information */}
      <div className="airsial-content">
        <h2>AIR SIAL</h2>
        <p className="airsial-highlight">CENTREX Marine Services is a member of Air Sial.</p>
        
        <div className="airsial-section">
          <h3>Our Vision</h3>
          <p>To be the Pride of Pakistan and become the leading airline of the region.</p>
        </div>
        
        <div className="airsial-section">
          <h3>Our Mission</h3>
          <p>To be a safe, operationally efficient, customer-centric, technology-driven airline that sustain itself through modern, innovative management.</p>
        </div>
        
        <div className="airsial-section">
          <h3>COMPANY PROFILE</h3>
          <p>Taking the lead from the exceptional success of the Sialkot International Airport Ltd. (SIAL), the members of the Sialkot Chamber of Commerce and Industry conceived the AIR SIAL project in August, 2015 to make it another success story.</p>
          
          <ul>
            <li>AIR SIAL is a licenced airline to provide scheduled passenger & cargo services in domestic and international markets.</li>
            <li>AIR SIAL is committed to offer services based on best safety & operational practices together with an attitude infused with hospitality & service standards par excellence.</li>
            <li>AIR SIAL is aiming to bring real value to the market and eventually become a game changer in the industry.</li>
            <li>The people of Sialkot who are part of the celebrated Golden Triangle are all set to be part of another triangle—the SILVER TRIANGLE whose lines are formed by the SCCI, SIAL and AIR SIAL.</li>
            <li>The motto of this new SILVER TRIANGLE shall be: Let's touch the SKY together</li>
          </ul>
        </div>
        
        <div className="airsial-link">
          <a href="https://www.airsial.com/" target="_blank" rel="noopener noreferrer">
            Visit Air Sial Official Website
          </a>
        </div>
      </div>
    </div>
  )
}

export default Airsial
